var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("custom-audio", { ref: "audio", attrs: { src: _vm.soundSrc } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }